<template>
  <cargo-advance-select
    ref="salesCompany"
    :select-type="TYPE_NAMES.basic_data_Company"
    :method-params="methodParams"
    :hand-trigger-value="$store.getters.currentOfficeUuid"
    :clear-not-match="clearNotMatch"
    filterable
    :disabled="disabled"
    :callback-params="callbackParams"
    :multiple="multiple"
    :default-value="defaultValue"
    :default-multiple-value="defaultMultipleValue"
    :tag-value="tagValue"
    options-width="optionsWidth"
    :headers="headers"
    :fields="fields"
    :tag-name="tagName"
    :placeholder="placeholder"
    :static-options="staticOptions"
    :popper-class="popperClass"
    :latest-used-data-key="latestUsedDataKey"
    @enter="$emit('enter')"
    @parentCallBack="onParentCallBack"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getFilterCacheList, getObjectByCache } from '@/utils/basicDataCache'
import { getCustomerByRole, getCustomerBySalesCsr } from '@/api/booking/job'
import { cacheName, cache } from '@/utils/cacheManager'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import { AdvanceSelect } from '@/utils/class/AdvanceSelect'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'

// 销售自己的客户
let companies = null
let companiesContainsNoCustomer = null
let companiesNotContainsNoCustomer = null

export default {
  name: 'CargoSalesCompanySelect',
  components: { cargoAdvanceSelect },
  props: {
    methodParams: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    callbackParams: { type: Object, default: null },
    multiple: { type: Boolean, default: false },
    defaultValue: { type: [String, Number, Boolean], default: '' },
    defaultMultipleValue: { type: [Array, String], default: () => { return [] } },
    tagValue: { type: String, default: '' },
    headers: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    tagName: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    popperClass: { type: String, default: null },
    checkCredit: { type: Boolean, default: false },
    optionsWidth: { type: String, default: null },
    clearNotMatch: { type: Boolean, default: false },
    useAccountObjectControlMode: { type: Boolean, default: true }, // 是否使用配置参数：AccountObjectControlMode（结算单位控制模式）
    job: { type: Object, required: false },
    containsNoCustomer: { type: Boolean, default: false }, // 目前只在 AccountObjectControlMode=2 时使用（将供应商加入到下拉里，即 未勾选客户的合作伙伴）
    latestUsedDataKey: { type: String, default: '' }
  },
  data() {
    return {
      TYPE_NAMES,
      staticData: null,
      staticOptions: null,
      accountObjectControlMode: false // 结算单位控制模式
    }
  },
  computed: {
    useStaticOptions() {
      return (this.useAccountObjectControlMode && this.accountObjectControlMode || !this.useAccountObjectControlMode) && !!this.staticData
    }
  },
  watch: {
    defaultValue() {
      this.resetStaticOptions()
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode')) === 1 || Number(cache.config.get('AccountObjectControlMode')) === 2
      }
    },
    useStaticOptions() {
      this.resetStaticOptions()
    }
  },
  async created() {
    const accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode'))
    if (this.useAccountObjectControlMode && accountObjectControlMode === 1 || (!this.useAccountObjectControlMode && [0, 1].indexOf(accountObjectControlMode) > -1)) {
      // （参数控制 且 参数 = 1） 或者 （不受参数控制 且 参数值 = 0、1） 下拉取销售（原逻辑）
      if (!this.$store.getters.isAdmin && (this.$checkPermission(['role_SalesQueryModule_salesCustomer']) || this.$checkPermission(['role_SalesQueryModule_departmentCustomer']))) {
        if (!companies) {
          await getCustomerByRole({ branch: this.$store.getters.currentOfficeId }).then(res => {
            companies = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.cmpIdx))
          })
        }
        this.staticData = companies
      }
    } else if (accountObjectControlMode === 2) {
      // 参数值=2时，下拉取销售+客服
      if (!this.$store.getters.isAdmin && (this.$checkPermission(['role_SalesQueryModule_salesCustomer']) || this.$checkPermission(['role_SalesQueryModule_departmentCustomer']) ||
        this.$checkPermission(['role_CsrQueryModule_csrCustomer']) || this.$checkPermission(['role_CsrQueryModule_departmentCustomer']))) {
        if (this.containsNoCustomer && companiesContainsNoCustomer) {
          this.staticData = companiesContainsNoCustomer
        } else if (!this.containsNoCustomer && companiesNotContainsNoCustomer) {
          this.staticData = companiesNotContainsNoCustomer
        } else {
          await getCustomerBySalesCsr({
            branch: this.$store.getters.currentOfficeId,
            containsNoCustomer: this.containsNoCustomer
          }).then(res => {
            const data = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.cmpIdx))
            this.staticData = data
            if (this.containsNoCustomer) {
              companiesContainsNoCustomer = data
            } else {
              companiesNotContainsNoCustomer = data
            }
          })
        }
      }
    }
    this.resetStaticOptions()
  },
  methods: {
    clear() {
      console.log('[ReleaseNumber] clear CargoSalesCompanySelect')
      if (this.$refs.salesCompany && this.$refs.salesCompany.toClear) {
        this.$refs.salesCompany.toClear()
      } else {
        this.$emit('clear')
      }
    },
    async onParentCallBack(data) {
      // 信控验证
      if (data && this.checkCredit) {
        await cache.load(cacheName.CONFIG)
        if (parseInt(cache.config.get('creditOpen')) === 1) {
          const companyId = data.value
          await CreditInfo.checkCreditInfo(companyId, CreditInfoUtil.getJobData(this.job)).then(res => {
            if (!res.data || res.data.length <= 0) return
            const credit = res.data[0]
            if (credit && credit.blacklist) {
              this.$message.warning(this.$t('Message.PartnersBeenAddedToBlacklist'))
              return
            }
            for (const item of res.data) {
              this.setCreditColor(item)
            }
          })
        }
      }
      this.$emit('parentCallBack', data)
    },
    setCreditColor(credit) {
      if (!credit) return
      if (credit.amountExceeded || credit.dateExceeded) {
        let s = ''
        if (credit.amountExceeded) { s += this.$t('Partners.credit_limit') + ' ' }
        if (credit.dateExceeded) { s += this.$t('Partners.accountPeriod') + ' ' }
        const toolTip = this.$t('Partners.parter') + ' ' + s + ' ' + this.$t('SeaExport.HasExceeded')
        this.$message.warning(toolTip)
      }
    },
    resetStaticOptions() {
      this.staticOptions = null
      if (this.useStaticOptions) {
        this.staticOptions = this.staticData
        if (this.staticOptions && !this.clearNotMatch) {
          let tagValue = this.tagValue
          if (!tagValue) {
            const advanceSelect = new AdvanceSelect(TYPE_NAMES.basic_data_Company, {}, null, null, { includeAllItem: false })
            tagValue = advanceSelect.typeInfo.tagValue
          }
          if (this.staticOptions.findIndex(p => p[tagValue]) < 0) {
            const cmp = getObjectByCache(TYPE_NAMES.basic_data_Company, tagValue, this.defaultValue)
            if (cmp) {
              this.staticOptions = [cmp, ...this.staticOptions]
            }
          }
        }
      }
    }
  }
}
</script>
